import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Placeholder({ title, subtitle }) {
  return (
    <div
      data-testid="placeholder-page"
      className="min-h-screen bg-white flex items-center justify-center px-6"
    >
      <div className="max-w-xl text-center">
        <p className="font-inter text-xs font-bold tracking-[0.22em] uppercase text-[#3B82F6] mb-4">
          DeMaxtore · CommodityBid™️
        </p>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-[#0B1F3A] leading-[1.1]">
          {title}
        </h1>
        <p className="mt-5 text-[#475569] text-base md:text-lg leading-relaxed">
          {subtitle}
        </p>
        <Link
          to="/"
          data-testid="placeholder-back-home"
          className="mt-10 inline-flex items-center gap-2 text-sm font-medium text-[#0B1F3A] hover:text-[#3B82F6] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to CommodityBid™️
        </Link>
      </div>
    </div>
  );
}
